export default __webpack_public_path__ + "static/media/bell.231f5278.svg";